<template>
  <v-container fluid>
    <v-row>
      <v-col cols='12' lg='10' offset-lg='1'>
        <div class='d-flex justify-space-between'>
          <h2 class='title mb-3'>
            {{ pageTitle }}
          </h2>
          <v-btn class='ma-5' color='success' @click='initialize'>
            追加する
            <v-icon right> mdi-plus</v-icon>
          </v-btn>
        </div>

        <permission-guard situation='footer_link_management'>
          <div class='col-4'>
            <v-alert dense outlined type='error' class='text-caption'>
              ※1. 優先度は0が最高で、数が大きくなるほど低くなります<br />
              ※2. 優先度が高いほど、フッターで先頭で表示されます。
            </v-alert>
          </div>
          <v-card elevation='1'>
            <v-card-subtitle class='pl-5 py-1'>
              <v-row>
                <v-col cols='1'></v-col>
                <v-col cols='1'>
                  <div class='text-caption text-center'>優先度</div>
                </v-col>
              </v-row>
            </v-card-subtitle>
            <v-list>
              <draggable
                v-model='footerLinks'
                class='p-footerLinkRow__block'
                ghost-class='p-footerLinkRow__block--ghost'
                tag='div'
                handle='.p-footerLinkRow__block--dragging-handle'
                :scroll-sensitivity='200'
                :force-fallback='true'
                :animation='200'
                @end='updatePriorities'
              >
                <v-list-item
                  v-for='(footerLink, index) in footerLinks'
                  :key='footerLink.id'
                  class='mb-3'
                >
                  <v-list-item-content>
                    <v-list-item-title class='mb-1'>
                      <v-row dense>
                        <v-col cols='1' class='text-center'>
                          <v-icon
                            class='p-footerLinkRow__block--dragging-handle'
                            large
                          >mdi-view-headline
                          </v-icon
                          >
                        </v-col>
                        <v-col cols='1' class='text-center'>
                          <v-avatar color='blue-grey lighten-5' size='30'>
                            <span class='text-subtitle-2'>{{ index }}</span>
                          </v-avatar>
                        </v-col>
                        <v-col
                          cols='3'
                          class='d-flex align-center justify-space-around'
                        >
                          <div class='text-subtitle-1'>
                            {{ footerLink.title }}
                          </div>
                        </v-col>
                        <v-col cols='4' class='d-flex align-center'>
                          <a
                            v-if='footerLink.url'
                            :href='footerLink.url'
                            class='d-block'
                            target='_blank'
                            style='text-decoration: underline'
                          >
                            {{ footerLink.url }}
                          </a>
                          <a
                            v-else-if='footerLink.pageable'
                            :href='pagePublicUrl(footerLink)'
                            class='d-block'
                            target='_blank'
                            style='text-decoration: underline'
                          >
                            {{ pagePublicUrl(footerLink) }}
                          </a>
                        </v-col>
                        <v-col
                          cols='3'
                          class='d-flex align-center justify-space-around'
                        >
                          <v-btn icon @click='edit(footerLink)'>
                            <v-icon> mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color='error'
                            @click='destroy(footerLink)'
                          >
                            <v-icon> mdi-delete</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </draggable>
            </v-list>

            <DataLoader :loading='loading' />
          </v-card>
        </permission-guard>
      </v-col>
    </v-row>

    <v-dialog v-model='dialog' persistent scrollable width='700'>
      <FooterLinkForm
        :footer-link='editableFooterLink'
        @change-footer-link='editableFooterLink = footerLink'
        @create='create'
        @update='update'
        @cancel-edit='dialog = false'
      />
    </v-dialog>
  </v-container>
</template>
<script>
import axios from 'axios'
import draggable from 'vuedraggable'
import PermissionGuard from '@/components/commons/PermissionGuard'
import DataLoader from '@/components/commons/DataLoader'
import FooterLinkForm from './form'
import headUtilsMixin from '@/mixins/head_utils'
import { deserialize } from 'deserialize-json-api'
import urlUtils from '@/mixins/url_utils'

export default {
  components: {
    PermissionGuard,
    DataLoader,
    FooterLinkForm,
    draggable
  },
  mixins: [headUtilsMixin, urlUtils],
  data: () => {
    return {
      pageTitle: 'フッターリンク',
      footerLinks: [],
      loading: true,
      dialog: false,
      editableFooterLink: {},
      defaultFooterLink: {
        id: null,
        title: '',
        url: '',
        priority: 0,
        pageable: null
      }
    }
  },
  mounted: function () {
    axios
      .get('/api/footer_links')
      .then(
        ({ data }) => {
          this.footerLinks = deserialize(data).data
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: `フッターリンクの取得に失敗しました（${error.response.data.errors.toString()}）`
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    filterdFooterLink (footerLink) {
      const pageableId = footerLink.pageable ? footerLink.pageable.id : null
      let pageableType = ''
      if (footerLink.pageableType === 'HtmlPage' || (footerLink.pageable && footerLink.pageable.type === 'htmlPage')) {
        pageableType = 'HtmlPage'
      }
      if (footerLink.pageableType === 'MediaPage' || (footerLink.pageable && footerLink.pageable.type === 'mediaPage')) {
        pageableType = 'MediaPage'
      }
      return {
        id: footerLink.id,
        title: footerLink.title,
        url: footerLink.url,
        priority: footerLink.priority,
        pageable_id: pageableId,
        pageable_type: pageableType
      }
    },
    initialize () {
      this.editableFooterLink = { ...this.defaultFooterLink }
      this.dialog = true
    },
    edit (footerLink) {
      this.editableFooterLink = { ...footerLink }
      this.dialog = true
    },
    create (footerLink) {
      this.$store.dispatch('LoaderStore/displayLoader')
      const query = {
        footerLink: this.filterdFooterLink(footerLink)
      }
      axios
        .post('/api/footer_links', query)
        .then(
          ({ data }) => {
            this.footerLinks.push(deserialize(data).data)
            this.sortedFooterLinksByPriority()
            const payload = {
              status: 200,
              message: '新規作成しました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.message
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
        .finally(() => {
          this.dialog = false
          this.$store.dispatch('LoaderStore/hideLoader')
        })
    },
    update (footerLink) {
      this.$store.dispatch('LoaderStore/displayLoader')
      const query = {
        footerLink: this.filterdFooterLink(footerLink)
      }
      axios
        .patch(`/api/footer_links/${footerLink.id}`, query)
        .then(
          ({ data }) => {
            const updatedFooterLink = deserialize(data).data
            Object.assign(
              this.footerLinks.find((item) => item.id === updatedFooterLink.id),
              updatedFooterLink
            )
            this.sortedFooterLinksByPriority()
            const payload = {
              status: 200,
              message: '変更を保存しました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.message
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
        .finally(() => {
          this.dialog = false
          this.$store.dispatch('LoaderStore/hideLoader')
        })
    },
    destroy (footerLink) {
      if (confirm('本当に削除しますか？')) {
        this.$store.dispatch('LoaderStore/displayLoader')
        axios
          .delete(`/api/footer_links/${footerLink.id}`)
          .then(
            () => {
              const index = this.footerLinks.findIndex(
                (v) => v.id === footerLink.id
              )
              this.footerLinks.splice(index, 1)

              const payload = {
                status: 200,
                message: '削除しました'
              }
              this.$store.dispatch('SystemMessageStore/createMessage', payload)
            },
            (error) => {
              const payload = {
                status: error.response.status,
                message: error.response.data.messages
              }
              this.$store.dispatch('SystemMessageStore/createMessage', payload)
            }
          )
          .finally(() => {
            this.$store.dispatch('LoaderStore/hideLoader')
          })
      }
    },
    sortedFooterLinksByPriority () {
      return this.footerLinks.sort((a, b) => {
        return a.priority - b.priority
      })
    },
    updatePriorities () {
      const query = {
        footerLinks: this.footerLinks.map((link, index) => ({ id: link.id, priority: index }))
      }
      axios.patch('/api/footer_links/bulk_priority_update', query)
        .then(
          ({ data }) => {
            this.footerLinks = deserialize(data).data
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.messages
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    },
    pagePublicUrl (footerLink) {
      if (footerLink.pageableType === 'HtmlPage') {
        return this.htmlPagePublicUrl(footerLink.pageable)
      }
      if (footerLink.pageableType === 'MediaPage') {
        return this.mediaPagePublicUrl(footerLink.pageable)
      }
    }
  }
}
</script>

<style scoped>
.p-footerLinkRow__block--dragging-handle:hover {
  cursor: grab;
}
</style>
